import React, {Component} from 'react'
import {Button, Spin} from 'antd'
import {ArrowsAltOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'

@inject('miceCadStore')
@observer
class miceCadOea extends Component {
  iframeRef = React.createRef()
  state = {
    isFullScreen: false,
  }

  handleFullScreen = () => {
    const iframeWrap = this.iframeRef.current

    if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
      // 如果当前处于全屏状态，则退出全屏
      if (document.exitFullscreen) {
        document.exitFullscreen().then()
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen()
      }
      this.setState({isFullScreen: false})
    } else {
      // 如果当前不处于全屏状态，则进入全屏
      if (iframeWrap.requestFullscreen) {
        iframeWrap.requestFullscreen()
      } else if (iframeWrap.mozRequestFullScreen) { // Firefox
        iframeWrap.mozRequestFullScreen()
      } else if (iframeWrap.webkitRequestFullscreen) { // Chrome, Safari and Opera
        iframeWrap.webkitRequestFullscreen()
      } else if (iframeWrap.msRequestFullscreen) { // IE/Edge
        iframeWrap.msRequestFullscreen()
      }
      this.setState({isFullScreen: true})
    }
  }

  componentDidMount() {
    const {miceCadStore} = this.props
    miceCadStore.getMiceCadUrl('1')
  }

  render() {
    const {miceCadStore} = this.props
    const {isFetching, miceCadUrl} = miceCadStore
    const {isFullScreen} = this.state

    return (
      <Spin spinning={isFetching}>
        <div className="container" ref={this.iframeRef}>
          <Button icon={<ArrowsAltOutlined/>}
                  className="mice-fullscreen-button"
                  style={isFullScreen ? {bottom: '1px'} : {bottom: '6px'}}
                  onClick={this.handleFullScreen}></Button>
          <iframe title="Mice Cad Oea" className={isFullScreen ? 'iframe-fullscreen-style' : 'iframe-not-fullscreen-style'}
                  src={miceCadUrl}></iframe>
        </div>
      </Spin>
    )
  }
}

export default withTranslation()(miceCadOea)
